import React from 'react'

export const LoadingWhatsNewDetails = () => (
  <div className="container-fluid">
    <div className="row justify-content-center">
      <div className="col-12 col-lg-10">
        <div className="header mt-md-5">
          <div className="header-body">
            <div className="row align-items-center">
              <div className="col">
                <h6 className="w-25 animate">&nbsp;</h6>
                <h1 className="w-50 animate">&nbsp;</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-between mt-5">
          <div className="col-xl-3">
            <div className="form-control animate" />
            <ul className="list-group list-group-flush d-none d-xl-block">
              {Array.from({ length: 12 })
                .fill(null)
                .map((_, i) => `loading-content-row-${i}`)
                .map((key) => (
                  <div key={key}>
                    <div className="animate mt-3 mb-2" />
                    <div className="animate mb-3" style={{ height: '2rem' }} />
                  </div>
                ))}
            </ul>
          </div>
          <div className="col-xl-9 mt-xl-0 mt-3">
            <div className="row justify-content-center">
              <div className="col-10">
                <div className="h2 animate w-50" />
                {Array.from({ length: 3 })
                  .fill(null)
                  .map((_, i) => `loading-content-${i}`)
                  .map((key) => (
                    <div key={key} className="animate mb-3" style={{ height: '2rem' }} />
                  ))}
                <div className="animate mb-3" style={{ height: '16rem' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)
